module.exports = __webpack_public_path__ + "img/Anavil_Sirop_Gray_1280x1010.568f946a.jpg";